import './ListPage.scss'

interface Props {
  children: React.ReactNode
}

export const ListPage = ({ children }: Props): JSX.Element => {
  return <div className='c-list-page'>{children}</div>
}
